module.exports = __webpack_public_path__ + "static/media/2 (2).38e3227a.jpg";